import {RPCDocs, useCurrentUser} from '@therms/react-modules'

export function useCurrentUserAnPCheck(
  check: (
    user: RPCDocs.Auth.GetIdentityInfo.v1.Data['user'],
  ) => boolean | undefined,
) {
  const currentUser = useCurrentUser()

  if (currentUser.superAdmin) return true

  return !!check(currentUser)
}
